<template>
  <div class="create-students">
    <button class="bttn bttn--primary" style="width: 200px" @click="setIsShowModal">
      {{ $t('vue2.students.create_student') }}
    </button>
    <Modal v-if="isShowModal"
           :is-bg-overlay="true"
           :show-close="false"
           @close="setCloseModal"
           :show="true">
      <div class="doc-modal" slot="insertComponent">
        <div class="doc-modal__header">
          <h2>{{ $t('vue2.common.create') }} <span v-if="!isCreateMultipleStudents">{{
              $t('vue2.students.student')
            }}</span><span v-else>{{ $t('vue2.students.students') }}</span></h2>
          <div class="doc-modal__close icon__bg-circle" @click="setCloseModal">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="doc-modal__body" v-if="isCreateMultipleStudents">
          <div class="input-group">
            <label class="d-label">{{ $t('vue2.students.insert_multiple_students') }}</label>
            <div class="textarea-placeholder-container">
              <textarea v-model="theBulkStudentsStr" style="height: 400px" spellcheck="false" autocapitalize="none"
                        autocomplete="off"></textarea>
              <div class="textarea-placeholder-container__placeholder" v-show="isShowTextAreaPlaceholder">
                Anne Anker
                <br/> Ella Madsen
                <br/> Michael Thomsen
              </div>
            </div>
          </div>
        </div>
        <div class="doc-modal__body" v-for="(student, key) in students" v-else>
          <div class="d-input-group" v-if="isFeideActive">
            <label class="d-label">{{ $t('vue2.students.feide') }}</label>
            <input type="text"
                   ref="feide"
                   placeholder=""
                   class="d-input feide"
                   :class="[{'input--error': isFeideAlreadyCreated}]"
                   v-model="student.feide"/>
            <p class="text--error" v-if="isFeideAlreadyCreated">{{ $t('vue2.students.feide_is_already_used') }}</p>
          </div>
          <div class="d-input-group">
            <label class="d-label">{{ $t('vue2.students.name') }}</label>
            <input type="text"
                   :id="'studentname_' + key"
                   ref="studentname"
                   :class="[{'missing-input': false}]"
                   placeholder=""
                   class="d-input namefield"
                   v-model="student.name"/>
          </div>
          <SearchForCalendar :query="student.name"></SearchForCalendar>
          <p class="text-blue pointer text-link" v-if="student.name.length < 1"
             @click="isCreateMultipleStudents = !isCreateMultipleStudents">
            {{ $t('vue2.students.create_multiple_students') }}</p>
        </div>
        <div class="doc-modal__footer">
          <button @click="setCloseModal" class="marg-1-right">{{ $t('vue2.common.cancel') }}</button>
          <button class="submit-button bttn--shadow"
                  :class="{'create-form__submit': showInactiveButton}"
                  @click="submit">
            {{ $t('vue2.common.create') }} <span v-if="!isCreateMultipleStudents">{{
              $t('vue2.students.student')
            }}</span><span v-else>{{ $t('vue2.students.students') }}</span>
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import docendo from '../../../docendo'
import eventbus from '../../../eventbus'
import Modal from '../../common/DModal'
import SearchForCalendar from '../../Students/SearchForCalendar'

export default {
  components: {Modal, SearchForCalendar},
  data () {
    return {
      students: [],
      isShowModal: false,
      theCreateCalendarsType: 'student',
      debounceTimer: null,
      isCreateMultipleStudents: false,
      theBulkStudentsStr: ''
    }
  },
  computed: {
    isShowTextAreaPlaceholder () {
      return this.theBulkStudentsStr.length < 1
    },
    theBulkStudentsArr () {
      let arr = this.theBulkStudentsStr.length > 0 ? this.theBulkStudentsStr.split('\n') : []
      return arr.filter(studentName => studentName.trim().length > 0)
    },
    isFeideActive () {
      return false
    },
    allStudents () {
      return this.$store.getters.studentCalendars
    },
    allFeideIds () {
      let feideids = []
      this.allStudents.forEach(student => {
        let feideId = student.custom_data['feide']
        if (feideId) {
          let idx = feideids.indexOf(feideId)
          if (idx < 0) {
            feideids.push(feideId)
          }
        }
      })
      return feideids
    },
    isFeideAlreadyCreated () {
      let isCreated = false
      if (this.students[0] && this.students[0].feide && this.students[0].feide.length > 0) {
        let idx = this.allFeideIds.indexOf(this.students[0].feide)
        if (idx > -1) {
          isCreated = true
        }
      }
      return isCreated
    },
    studentsWithSameName () {
      return this.students[0].name.length > 0
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    showInactiveButton () {
      if (this.studentsToSubmit.length < 1) {
        return true
      }
    },
    studentsToSubmit () {
      let studentsToSubmit = []
      if (this.isCreateMultipleStudents) {
        this.theBulkStudentsArr.forEach(studentName => {
          let studentObj = {
            name: studentName,
            type: 'student'
          }
          studentsToSubmit.push(studentObj)
        })
      } else {
        for (let i = 0; i < this.students.length; i++) {
          if (this.students[i].name.length > 0) {
            let userobj = {
              name: this.students[i].name,
              type: 'student'
            }
            if (this.students[i].unilogin.length > 0) {
              userobj.unilogin = this.students[i].unilogin
            }
            if (this.students[i].feide.length > 0) {
              userobj.feide = this.students[i].feide
            }
            if (this.students[i].email.length > 0) {
              userobj.email = this.students[i].email
            }
            studentsToSubmit.push(userobj)
          }
        }
      }
      return studentsToSubmit
    }
  },
  methods: {
    setIsShowModal () {
      this.isShowModal = true
      this.pushNewStudent()
      window.setTimeout(_ => {
        let el = document.getElementById('studentname_0')
        if (el) {
          el.focus()
        }
      }, 400)
    },
    setCloseModal () {
      this.isShowModal = false
      this.cleanForm()
    },
    cleanForm () {
      this.students = []
      this.theBulkStudentsStr = ''
    },
    pushNewStudent () {
      this.students.push({
        name: '',
        type: this.theCreateCalendarsType,
        isSameName: false,
        unilogin: '',
        feide: '',
        email: ''
      })
      if (this.students.length > 4) {
        setTimeout(() => {
          this.scrollInDiv()
        }, 0)
      }
    },
    scrollInDiv () {
      var objDiv = document.querySelector('.modal-body')
      objDiv.scrollTop = objDiv.scrollHeight
    },
    submit () {
      if (this.showInactiveButton) {
        return
      }
      let successText = this.studentsToSubmit.length > 1 ? this.$t('vue2.students.created_student') : this.$t('vue2.students.created_student')
      docendo.schoolBulkCreateCalendars(window.SCHOOL.id, this.activeSchoolYear.id, this.studentsToSubmit, success => {
        eventbus.toast = {text: successText, 'success': true}
        this.cleanForm()
        this.pushNewStudent()
        this.$store.dispatch('getSchoolCalendars', window.SCHOOL.id)
      }, errors => {
        eventbus.toast = {text: this.$t('vue2.toast.something_went_wrong'), 'success': false}
      })

      // this.setCloseModal()
    },
    checkAllForText () {
      this.usersWithText = []
      for (let i = 0; i < this.users.length; i++) {
        if (this.users[i].name.length > 0) {
          this.usersWithText.push(this.users[i])
        }
      }
      this.$emit('editedUsers', this.usersWithText)
      if (this.usersWithText.length === this.users.length) {
        this.pushNewUser()
      }
    },
    validate (user, key) {
      if (user.name.length >= 0) {
        this.students[key].nameIsValid = true
      }
      if (user.feide.length > 0 && user.name.length < 1) {
        this.students[key].nameIsValid = false
      }
    },
    unValidate (user, key) {
      this.users[key].nameIsValid = true
    }
  }
}
</script>

<style scoped>
@import '../../../assets/css/variables.css';

.text--error {
  color: var(--danger);
}

.doc-modal__large {
  max-width: 800px;
  min-width: 800px;
}

.students-to-create > div {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}

.students-to-create > div > div {
  flex: 1;
}

.students-to-create > div > div:not(:last-child) {
  margin-right: 1rem;
  width: calc(800px - 150px - 2rem);
}

.students-to-create__student__name {
  min-width: 350px;
}

.students-to-create__student__grade {
  width: 150px;
}

.students-to-create__student__grade select {
  width: 150px;
}

.students-to-create > div > div input {
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
  border: 1px solid #edf2f7;
}

.students-to-create > div > div input:focus {
  border-color: var(--blue);
}

.doc-modal__footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem 5rem;
}

.bttn--shadow {
  box-shadow: 0 2px 5px -1px rgb(50 50 93 / 25%), 0 1px 3px -1px rgb(0 0 0 / 30%);
}

.create-form__submit {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
  border: 1px solid #d8d8d8 !important;
  box-shadow: none !important;
}

.d-input {
  padding: 9px;
}

.d-input-group {
  margin-bottom: 1rem;
}

.d-input-group .d-label {
  margin-bottom: 6px;
}

.doc-modal__footer {
  padding: 2rem;
  display: flex;
  justify-content: flex-end;
}

.textarea-placeholder-container {
  position: relative;
}

.textarea-placeholder-container textarea {
  padding: 1rem;
  background: #ffffff;
}

.textarea-placeholder-container__placeholder {
  position: absolute;
  top: calc(1rem + 1px);
  left: calc(1rem + 1px);
  z-index: 1;
  color: #9f9f9f;
  pointer-events: none;
}

.text-link:hover {
  text-decoration: underline;
}

</style>



// WEBPACK FOOTER //
// CreateStudents.vue?2759dfb8